import type { CSSProperties, ReactNode } from 'react';

export function Kbd({ children }: { children: ReactNode }) {
  return <kbd className="dxl-kbd">{children}</kbd>;
}

export function Skelett({ breite = '100%', style }: { breite?: string | number; style?: CSSProperties }) {
  return <span className="dxl-skelett" style={{ width: breite, ...style }} aria-hidden />;
}

export function Karte({ children, className }: { children: ReactNode; className?: string }) {
  return <section className={['dxl-karte', className].filter(Boolean).join(' ')}>{children}</section>;
}

/* Gleiche Kennung → gleiche Farbe. Gedeckte Töne aus der DXL-Palette, alle mit weißer Schrift lesbar. */
const TOENE = ['#0B7A76', '#05565A', '#283037', '#3C5A78', '#5B4B8A', '#8A4B5E', '#7A5B12', '#2F6B3E'];
function ton(text: string): string {
  let h = 0;
  for (const z of text) h = (h * 31 + z.charCodeAt(0)) >>> 0;
  return TOENE[h % TOENE.length]!;
}

/** text = angezeigte Zeichen (z. B. Initialen), farbeVon = stabile Kennung für die Farbe (z. B. Kürzel) */
export function Monogramm({ text, farbeVon, groesse = 28 }: { text: string; farbeVon?: string; groesse?: number }) {
  return (
    <span
      className="dxl-monogramm"
      style={{ background: ton(farbeVon ?? text), width: groesse, height: groesse, fontSize: Math.round(groesse * 0.38) }}
      aria-hidden
    >
      {text.slice(0, 2).toUpperCase()}
    </span>
  );
}
